window.main = window.main || {};

main.defineGlobalVars = function () {
	var selectors = {
    // html: document.getElementsByTagName('html')[0],
    // body: document.getElementsByTagName('body')[0],
  };

  main.vars = selectors;
};

main.cacheSelectors = function () {
  var cache = {
    didScroll     : false,
    prevScrollY   : 0
  };
  main.cache = cache;
};

main.init = function () {
  main.cacheSelectors();
  main.detectScroll(); // onscroll event
  requestAnimationFrame(main.scrollAction); // onscroll action
  main.defineGlobalVars();
  main.cookie.init();
  main.masonry.init();
  main.navigation.init();
  main.dropdown.init();
  main.window.init();
  main.scroll.init();
};

main.detectScroll = function() {
    window.onscroll = function() {
        /* Alrighty the user is scrolling! So we are setting a variable to indicate this action. */
        main.cache.didScroll = true;
    };
};

main.scrollAction = function() {
    if(main.cache.didScroll) {
      /* 
      * To detect the direction, we keep track of the previous scrollposition
      */
      var header = document.getElementsByClassName('js-header')[0];
      var currentPosition = window.pageYOffset;
      if(!main.utils.hasClass(header, 'is-active')) {
        if (currentPosition <= 0) {
          main.utils.removeClass(header, 'is-hidden');
          main.utils.addClass(header, 'is-sticky');
        } else 
        if(main.cache.prevScrollY > currentPosition) { 
            /* you are scrolling down */
            main.utils.removeClass(header, 'is-hidden');
            main.utils.addClass(header, 'is-sticky');

        } else { 
            /* you are scrolling up */
            main.utils.addClass(header, 'is-hidden');
            main.utils.addClass(header, 'is-sticky');
        }
      }
      main.cache.didScroll = false;
      main.cache.prevScrollY = currentPosition; 
    }
    
    /*
    * RAF prevents performance issues. 
    * You can also use a setInterval of 100ms.
    * But RAF asks the browser to call this function whenever your brower is ready.
    */
    requestAnimationFrame(main.scrollAction);
};

main.hideNav = function () {
  // if (header.classList.contains('is-visible')) return false
  // var currentPosition = window.pageYOffset || document.documentElement.scrollTop
  // if (Math.abs(currentPosition - previousPosition) < 20) {
  //     return
  // }
  // if (currentPosition <= 172) {
  //     main.utils.removeClass(header, 'is-hidden');
  //     main.utils.removeClass(header, 'is-sticky');
  // } else if (previousPosition > currentPosition) {
  //     main.utils.removeClass(header, 'is-hidden');
  //     main.utils.addClass(header, 'is-sticky');
  // } else {
  //     main.utils.addClass(header, 'is-hidden');
  //     main.utils.addClass(header, 'is-sticky');
// }
};

// Initialize main JS on docready
document.addEventListener('DOMContentLoaded',function(){main.init();});
